"use client";
import { useEffect, useState } from "react";
import { useT } from "providers/I18nProvider";

/**
 * Câu giới thiệu dưới tên section tự đổi mỗi 2 phút cho đỡ nhàm.
 *
 * Cách hoạt động: mỗi tagline có 4 biến thể trong file dịch —
 *   home.xxxDesc  (biến thể 1)  ·  home.xxxDesc2  ·  home.xxxDesc3  ·  home.xxxDesc4
 * Biến thể đang hiển thị = mốc thời gian hiện tại chia cho 2 phút, lấy dư 4.
 * Mọi tab/máy đang mở cùng lúc sẽ thấy cùng một câu.
 *
 * Vì sao khởi tạo index = 0 rồi mới cập nhật trong useEffect: HTML do server
 * render không được khác HTML client render lần đầu, nếu tính theo Date.now()
 * ngay lúc render sẽ bị lỗi hydration mismatch.
 */
export const ROTATE_MS = 2 * 60 * 1000; // 2 phút
export const TAGLINE_VARIANTS = 4;

export const taglineSlot = (now: number = Date.now()) =>
  Math.floor(now / ROTATE_MS) % TAGLINE_VARIANTS;

const useRotatingTagline = (baseKey: string, fallback?: string): string => {
  const t = useT();
  const [slot, setSlot] = useState(0);

  useEffect(() => {
    setSlot(taglineSlot());
    let interval: ReturnType<typeof setInterval> | undefined;
    // Canh đúng mốc 2 phút tiếp theo rồi mới lặp đều, để các section đổi cùng nhịp.
    const delay = ROTATE_MS - (Date.now() % ROTATE_MS);
    const timeout = setTimeout(() => {
      setSlot(taglineSlot());
      interval = setInterval(() => setSlot(taglineSlot()), ROTATE_MS);
    }, delay);
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  const key = slot === 0 ? baseKey : `${baseKey}${slot + 1}`;
  const text = t(key);
  // t() trả lại chính key khi thiếu bản dịch → lùi về biến thể gốc.
  if (!text || text === key) {
    const base = t(baseKey);
    return base && base !== baseKey ? base : fallback || "";
  }
  return text;
};

export default useRotatingTagline;
